module.exports = "/static/assets/d5daff71b359c33eb3d8a6647567d53a.png";